const MIME_EXTENSIONS=Object.freeze({
  'image/jpeg':'jpg',
  'image/png':'png',
  'image/webp':'webp'
});

export const SMOKER_PHOTO_MAX_BYTES=5*1024*1024;

function requiredId(value,label){
  const id=String(value||'').trim();
  if(!id)throw new TypeError(`${label} is required`);
  if(!/^[A-Za-z0-9_-]{1,128}$/.test(id))throw new TypeError(`Invalid ${label}`);
  return id;
}

function photoExtension(mimeType){
  const mime=String(mimeType||'').trim().toLowerCase();
  const ext=MIME_EXTENSIONS[mime];
  if(!ext)throw new TypeError('Unsupported smoker photo type');
  return ext;
}

export function validateSmokerPhotoFile({mimeType,sizeBytes}={}){
  const ext=photoExtension(mimeType);
  const size=Number(sizeBytes);
  if(!Number.isInteger(size)||size<1||size>SMOKER_PHOTO_MAX_BYTES){
    throw new TypeError('Smoker photo size must be between 1 byte and 5 MB');
  }
  return Object.freeze({mimeType:String(mimeType).toLowerCase(),extension:ext,sizeBytes:size});
}

export function buildSmokerPhotoPath({userId,smokerId,mimeType}={}){
  const user=requiredId(userId,'userId');
  const smoker=requiredId(smokerId,'smokerId');
  const ext=photoExtension(mimeType);
  return `${user}/smokers/${smoker}/cover.${ext}`;
}

export function isOwnedSmokerPhotoPath(path,{userId,smokerId}={}){
  const user=requiredId(userId,'userId');
  const smoker=requiredId(smokerId,'smokerId');
  const value=String(path||'').trim();
  return value.startsWith(`${user}/smokers/${smoker}/`);
}

export function planSmokerPhotoReplacement({
  userId,
  smokerId,
  currentPath=null,
  mimeType,
  sizeBytes,
  localPreviewUri=null
}={}){
  const file=validateSmokerPhotoFile({mimeType,sizeBytes});
  const uploadPath=buildSmokerPhotoPath({userId,smokerId,mimeType:file.mimeType});
  const previous=String(currentPath||'').trim()||null;
  if(previous&&!isOwnedSmokerPhotoPath(previous,{userId,smokerId})){
    throw new TypeError('Existing smoker photo path is outside the owner scope');
  }
  return Object.freeze({
    status:'pending_upload',
    uploadPath,
    deleteAfterUpload:previous&&previous!==uploadPath?previous:null,
    localPreviewUri:localPreviewUri?String(localPreviewUri):null,
    mimeType:file.mimeType,
    sizeBytes:file.sizeBytes
  });
}

export function planSmokerPhotoRemoval({userId,smokerId,currentPath}={}){
  const path=String(currentPath||'').trim();
  if(!path)return Object.freeze({status:'none',deletePath:null});
  if(!isOwnedSmokerPhotoPath(path,{userId,smokerId})){
    throw new TypeError('Existing smoker photo path is outside the owner scope');
  }
  return Object.freeze({status:'pending_delete',deletePath:path});
}

export function smokerPhotoPlaceholder({hasLocalPreview=false,isOffline=false}={}){
  if(hasLocalPreview)return 'local_preview';
  if(isOffline)return 'offline_placeholder';
  return 'empty_placeholder';
}
